import React, { useState } from 'react';
import vendorStyles from './specificationsTab.module.css';
import { Download, Filter } from '../../../../Svg';
import { Menu, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { formateDate } from '../../../../Website/utils/utils';
import { useNavigate } from 'react-router-dom';

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '014px',
  color: '#667085',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  borderRadius: "4px",
  height: "40px",
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AllVenEnquiresTable = ({data, tableStyles}) => {

  const styles = tableStyles || vendorStyles;
  const isReceivedWorkspace = Boolean(tableStyles);

  const navigate = useNavigate()



  return (
    <>
      <div className={styles.receivedTableWrap || ''}>
      <table className={styles.receivedTable || styles.spectable}>
        <thead>
          <tr>
            <th>Enquiry ID</th>
            <th>Date</th>
            <th>Products</th>
            {/* <th>Total</th> */}
            <th>Status</th>
            <th className={isReceivedWorkspace ? styles.receivedActionHeader : ''}>{isReceivedWorkspace ? 'Action' : ''}</th>
          </tr>
        </thead>
        <tbody className={styles.spectbody}>
          {data?.map((record) => (
            <tr key={record?._id}>
              <td>{isReceivedWorkspace ? <span className={styles.receivedId}>#{record?._id}</span> : `#${record?._id}`}</td>
             <td>{isReceivedWorkspace ? <span className={styles.receivedDate}>{formateDate(record?.createdAt)}</span> : formateDate(record?.createdAt)}</td>
              <td>{isReceivedWorkspace ? <><span className={styles.receivedProductCount}>{record?.partCount || 1}</span><span className={styles.receivedProductLabel}>{record?.partCount === 1 ? 'product' : 'products'}</span></> : (record?.partCount || 1)}</td>
              {/* <td>{record.total}</td> */}
              <td>{isReceivedWorkspace ? <span className={`${styles.receivedStatus} ${record?.status === 'NEW' ? styles.receivedStatusNew : record?.status === 'QUOTED' ? styles.receivedStatusQuoted : styles.receivedStatusComplete}`}>{record?.status || 'NEW'}</span> : <span style={{color: record?.status == "NEW" ? '#4A4C56' : record?.status == "QUOTED" ? "#F86624" : "#1A9882"}}>{record.status}</span>}</td>
              <td className={isReceivedWorkspace ? styles.receivedActionCell : styles.speccheck}>
                {isReceivedWorkspace ? <button type="button" className={styles.receivedViewButton} onClick={()=>navigate(`/vendorEnquiryDetails/${record?._id}`)}>View details <span aria-hidden="true">→</span></button> : <div onClick={()=>navigate(`/vendorEnquiryDetails/${record?._id}`)} style={{color:'#885EFE',cursor:'pointer',fontWeight:500,fontSize:14}}>View Details</div>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </>
  );
};

export default AllVenEnquiresTable;
